import { SwitchKBComponent } from 'src/pages/ControlDeskPage/DataSourceSection/KnowledgeBases/AssignKnowledgeBasePopup/SwitchKBComponent';
import {
  useAssignProjectKnowledgeBaseMutation,
  useGetProjectByIdQuery,
  useUnassignProjectKnowledgeBaseMutation,
} from 'src/services';
import { useParams } from 'react-router-dom';
import { ProductsTypeBack } from 'src/constants/products';
import type { KnowledgeBase } from 'src/services/knowledgeBaseService';

export const AssignKnowledgeBaseListItem = ({
  knowledgeBase,
}: {
  knowledgeBase: KnowledgeBase;
}) => {
  const { id } = useParams();
  const { data: currentProject } = useGetProjectByIdQuery({ id: id });
  const defaultChecked = knowledgeBase.projects.some((project) => `${project.id}` === id);

  const [assignKB, { isLoading: assignKBisLoading }] = useAssignProjectKnowledgeBaseMutation();
  const [unassignKB, { isLoading: unassignKBIsLoading }] =
    useUnassignProjectKnowledgeBaseMutation();

  const onCheckedChange = (checked: boolean) => {
    const request = {
      project_type: ProductsTypeBack[currentProject?.project_type],
      projectId: currentProject.id,
      body: [knowledgeBase.id],
    };

    checked ? assignKB(request) : unassignKB(request);
  };

  return (
    <li className={'flex flex-row justify-between w-full pb-2.5 border-b border-light'}>
      <div>
        <p className={'text-ebony_opacity_80 font-medium text-sm'}>{knowledgeBase.name}</p>
      </div>
      <div>
        <SwitchKBComponent
          defaultChecked={defaultChecked}
          onCheckedChange={onCheckedChange}
          isFetching={assignKBisLoading || unassignKBIsLoading}
        />
      </div>
    </li>
  );
};
